export const CALENDLY_URL = "https://calendly.com/smileinn"
export const CALENDLY_PAGE_SETTINGS = {
  backgroundColor: "ffffff",
  hideEventTypeDetails: false,
  hideLandingPageDetails: false,
  primaryColor: "C79836",
  textColor: "4d5055",
}
export const WP_INVISALIGN_PAGE_ID = "a78f1e74-6a64-5aa9-a60b-288d6c851703"
